(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/init.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const ApiProvider = window.RTKQ.ApiProvider;
const _svs$grassroots$pages = svs.grassroots.pages,
  Start = _svs$grassroots$pages.Start,
  SearchResults = _svs$grassroots$pages.SearchResults,
  Result = _svs$grassroots$pages.Result;
const grassrootsQueryApi = svs.grassroots.store.grassrootsQueryApi;
const _svs$app$ReactRouter = svs.app.ReactRouter,
  PlayerRouter = _svs$app$ReactRouter.PlayerRouter,
  Route = _svs$app$ReactRouter.Route;
const baseUrl = svs.core.data.baseUrl;
const links = svs.grassroots.links;
const Context = React.createContext(null);
const InitComponent = () => {
  const isAuthenticated = svs.core.userSession && svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);

  const _grassrootsQueryApi$u = grassrootsQueryApi.useFetchReceiverSelectionQuery('', {
      skip: !isAuthenticated
    }),
    data = _grassrootsQueryApi$u.data,
    isLoading = _grassrootsQueryApi$u.isLoading;
  const _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    selectedReceivers = _React$useState2[0],
    setSelectedReceivers = _React$useState2[1];
  const _React$useState3 = React.useState(true),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    countNumbers = _React$useState4[0],
    setCountNumbers = _React$useState4[1];
  React.useEffect(() => {
    if (data !== undefined) {
      setSelectedReceivers(data);
    }
  }, [data]);
  return React.createElement(PlayerRouter, {
    basename: baseUrl,
    withRouter: true
  }, React.createElement(Context.Provider, {
    value: {
      selectedReceivers: {
        selectedReceivers,
        setSelectedReceivers,
        isLoading
      },
      countNumbers: {
        countNumbers,
        setCountNumbers
      }
    }
  }, React.createElement(Route, {
    exact: true,
    path: links.start,
    render: () => React.createElement(Start, null)
  }), React.createElement(Route, {
    exact: true,
    path: links.singlePattern,
    render: () => React.createElement(Start, null)
  }), React.createElement(Route, {
    path: links.search,
    render: () => React.createElement(SearchResults, null)
  }), React.createElement(Route, {
    path: links.result,
    render: () => React.createElement(Result, null)
  })), React.createElement(Route, {
    path: links.marketing,
    render: () => {
      window.location.href = svs.grassroots_shared_2.data.config.grassrootsPartnerMarketing;
      return null;
    }
  }));
};
svs.grassroots.context.Context = Context;
ReactDOM.render(React.createElement(ApiProvider, {
  api: grassrootsQueryApi
}, React.createElement(InitComponent, null)), document.querySelector('.receivers-app'));

 })(window);